var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "order__steps" }, [
    _c(
      "span",
      {
        staticClass: "order__steps__productname",
        attrs: { "data-test": "product-name" },
      },
      [_vm._v("\n    " + _vm._s(_vm.productName) + "\n  ")]
    ),
    _vm._v(" "),
    _c(
      "ul",
      { staticClass: "order__steps__menu" },
      _vm._l(_vm.orderSteps, function (orderStep, index) {
        return _c(
          "li",
          {
            key: index,
            staticClass: "order__steps__item",
            class: { "order__steps__item--active": orderStep.active },
            attrs: { "data-test-step": index },
          },
          [
            orderStep.active || orderStep.disabled
              ? _c("p", { staticClass: "m-0" }, [
                  _c("span", { staticClass: "order__steps__number" }, [
                    _vm._v(_vm._s(++index)),
                  ]),
                  _vm._v("\n\n        " + _vm._s(orderStep.title) + "\n      "),
                ])
              : _c(
                  "a",
                  {
                    staticClass: "order__steps__link",
                    attrs: { href: orderStep.url },
                    on: {
                      click: function ($event) {
                        return _vm.onMenuItemClick($event, orderStep)
                      },
                    },
                  },
                  [
                    _c("span", { staticClass: "order__steps__number" }, [
                      _vm._v(_vm._s(++index)),
                    ]),
                    _vm._v(
                      "\n\n        " + _vm._s(orderStep.title) + "\n      "
                    ),
                  ]
                ),
          ]
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }